"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Store
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
// Components
var FAQUpload_1 = __importDefault(require("./FAQUpload"));
var FAQUploadWrapper = function (_a) {
    var _b;
    var isEmptyList = _a.isEmptyList;
    var domainData = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain;
    return (react_1["default"].createElement(FAQUpload_1["default"], { isEmptyList: isEmptyList, uploadFAQNodes: BotActions_1.uploadFAQNodes, downloadFAQNodes: BotActions_1.downloadFAQNodes, botId: domainData.id, botTitle: domainData.title }));
};
exports["default"] = FAQUploadWrapper;
